import {useSyncSkills} from '../../services/hooks';

export function useStaffListLogic() {
  const {skillsApi, skills} = useSyncSkills();

  return {skillsApi, skills};
}
